import { Component, inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, debounceTime } from 'rxjs';
import { PortService } from 'src/app/shared/service/disbursment/port.service';
import { CreatePortTariffComponent } from '../../../dis-repository/pages/create-port-tariff/create-port-tariff.component';
import { MaPort } from '../../../dis-repository/pages/create-port-tariff/port.model';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { ToastrService } from 'ngx-toastr';
import { ViewFieldsComponent } from '../../../dis-repository/pages/create-port/view-fields/view-fields.component';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-port',
  templateUrl: './port.component.html',
  styleUrls: ['./port.component.scss']
})
export class PortComponent {
 constructor(
    private loaderService: DisbursmentService,
    private portService: PortService,
    private snackBar: ToastrService,
    private dialog: MatDialog,
    private requestFormService: RequestFormService,
  ) { }

 private loader = inject(DisbursmentService);
 isLoading$ = this.loader.loading$;
  searchTerm: string = '';
  displayedColumns = ['Sl.No', 'country', 'name', 'Action'];
  dataSource = new MatTableDataSource<any>();
  currentPage = 1;
  pageSize = 50;
  allDataLoaded = false;
  totalCount = 0;
  private searchSubject = new Subject<string>();

  ngOnInit() {
    this.getMaPortTariffRules(true);
    // Setup debounce for search
    this.searchSubject
      .pipe(
        debounceTime(1000)
      )
      .subscribe(() => {
        this.onSearch();
      });
  }

  ngOnDestroy() {
    this.searchSubject.complete();
  }

  inputSearch(): void {
    if (this.searchTerm.trim() === '') {
      this.onSearch();
    } else {
      this.searchSubject.next(this.searchTerm);
    }
  }

  //method to filter the records in db
  onSearch(): void {
    this.getMaPortTariffRules(true);
  }

  // method to clear the searchterm
  clearSearch() {
    this.searchTerm = '';
    this.getMaPortTariffRules(true);
  }

  // method to fetch the tariff rules from db
  getMaPortDataFromDb(reset = false) {
    if (reset) {
      this.currentPage = 1;
      this.allDataLoaded = false;
      this.dataSource.data = [];
      this.totalCount = 0;
    }

    const body = {
      page: this.currentPage,
      page_size: this.pageSize,
      query: this.searchTerm.trim(),
    };

    this.loaderService.show();

    this.portService.portDataFromDb(body).subscribe({
      next: (response: { data: MaPort[]; total_count: number }) => {
        const newData = response.data;
        this.totalCount = response.total_count;

        this.dataSource.data = [...this.dataSource.data, ...newData];
        if (this.dataSource.data.length >= this.totalCount) {
          this.allDataLoaded = true;
        }

        this.currentPage++;
        this.loaderService.hide();
      },
      error: (err) => {
        console.error('Error fetching tariff rules:', err);
        this.snackBar.error('Something went wrong. Please try again later.');
        this.loaderService.hide();
      }
    });
  }


  getMaPortTariffRules(reset = false) {
    if (reset) {
      this.currentPage = 1;
      this.allDataLoaded = false;
      this.dataSource.data = [];
      this.totalCount = 0;
    }
    const body = {
      page: this.currentPage,
      page_size: this.pageSize,
      query_name: this.searchTerm.trim(),
    };

    this.loaderService.show();

    this.portService.getTariffRules(body).subscribe({
      next: (response: any) => {
        const newData = response.data;
        this.totalCount = response.total;
        this.dataSource.data = [...this.dataSource.data, ...newData];

        if (this.dataSource.data.length >= this.totalCount) {
          this.allDataLoaded = true;
        }

        this.currentPage++;
        this.loaderService.hide();
      },
      error: (err) => {
        console.error('Error fetching tariff rules:', err);
        this.snackBar.error('Something went wrong. Please try again later.');
        this.loaderService.hide();
      }
    });
  }
  //calling the portlist api on scroll 
  onManualScroll(): void {
    const scrollContainer = document.querySelector('.table-container');

    if (scrollContainer) {
      const scrollPosition = scrollContainer.scrollTop + scrollContainer.clientHeight;
      const scrollHeight = scrollContainer.scrollHeight;

      if (
        scrollPosition >= scrollHeight - 10 &&
        !this.loaderService.loading$ &&
        !this.allDataLoaded
      ) {
        this.getMaPortTariffRules();
      }
    }
  }

  // method to open AddPortDialog
  openAddPortDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { right: '0' };
    dialogConfig.height = '100%';
    dialogConfig.width = '96vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = ['animate__animated', 'animate__slideInRight'];

    const dialogRef = this.dialog.open(CreatePortTariffComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'refresh') {
        // this.getMaPortDataFromDb(true);
        this.getMaPortTariffRules(true);
      } else if (result && result.data) {
        // Handle the returned tariff data

        // Here you can process the data as needed
        // For example, you might want to save it to a local storage or state management
        // Or you might want to make an API call to save it

        // For now, just show a success message
        this.snackBar.success('Tariffs saved successfully');
      }
    });
  }

  // method to open EditPortDialog
  openEditPortDialog(rowData: MaPort) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { right: '0' };
    dialogConfig.height = '100%';
    dialogConfig.width = '96vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = ['animate__animated', 'animate__slideInRight'];
    dialogConfig.data = { rowData };


    const dialogRef = this.dialog.open(CreatePortTariffComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'refresh') {
        // this.getMaPortDataFromDb(true);
        this.getMaPortTariffRules(true);
      } else if (result && result.data) {
        // Handle the returned tariff data


        // Here you can process the data as needed
        // For example, you might want to save it to a local storage or state management
        // Or you might want to make an API call to save it

        // For now, just show a success message
        this.snackBar.success('Tariffs updated successfully');
      }
    });
  }

  // method to open dialog to add the additional vessel fields
  openViewFieldsDialog(vessel_fields: any) {
    const data = {
      vessel_fields: vessel_fields.vessel_fields,
    }
    this.dialog.open(ViewFieldsComponent, {
      data: data,
      width: '450px',
      disableClose: true,
    });
  }
    isDarkMode() {
    return this.requestFormService.isDarkMode();
  }



  // Add method inside PortComponent class
onFilesSelected(event: Event, portId: number): void {
  const input = event.target as HTMLInputElement;
  if (!input.files || input.files.length === 0) {
    return;
  }

  const formData = new FormData();
  for (let i = 0; i < input.files.length; i++) {
    formData.append('files', input.files[i]);
  }

  this.loaderService.show();
  // this.portService.uploadPortTariffFiles(portId, formData).subscribe({
  //   next: (res: any) => {
  //     this.snackBar.success('Tariff service files uploaded successfully.');
  //     this.loaderService.hide();
  //     input.value = ''; // Reset file input
  //   },
  //   error: (err: any) => {
  //     console.error('Error uploading tariff files:', err);
  //     this.snackBar.error('Failed to upload tariff files. Please try again.');
  //     this.loaderService.hide();
  //     input.value = '';
  //   }
  // });
}

openViewFilesDialog(element: any): void {
  // this.dialog.open(ViewPortFilesComponent, {
  //   width: '600px',
  //   data: {
  //     port_id: element.port_id,
  //     port_name: element.port_name
  //   }
  // });
}
}
